import { FC } from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import {
  AI_LISTENING_BRAND_NEW_ROUTE,
  AI_LISTENING_BRAND_ROUTE,
  AI_LISTENING_PROMPT_DETAILS_ROUTE,
} from 'src/constants/routes'

// Redirects that keep the query string (the date filter) on the way.

// /ai-listening → /ai-listening/brand
export const AiListeningHomeRedirect: FC = () => {
  const { search } = useLocation()
  return <Navigate replace to={`${AI_LISTENING_BRAND_ROUTE}${search}`} />
}

// /ai-listening/new (the old "create campaign") → Create Brand Profile
export const AiListeningNewCampaignRedirect: FC = () => {
  const { search } = useLocation()
  return <Navigate replace to={`${AI_LISTENING_BRAND_NEW_ROUTE}${search}`} />
}

// /ai-listening/details/:campaignId and /ai-listening/campaign/:campaignId —
// a campaign is a prompt now, so old links open its deep-dive.
export const AiListeningCampaignRedirect: FC = () => {
  const { campaignId = '' } = useParams<{ campaignId: string }>()
  const { search } = useLocation()
  return (
    <Navigate
      replace
      to={`${AI_LISTENING_PROMPT_DETAILS_ROUTE.replace(
        ':promptId',
        encodeURIComponent(campaignId)
      )}${search}`}
    />
  )
}
